export const HASH_TAGS = ['tutorials videos', 'engagement', 'survey', 'worker engagement', 'e-learning', 
  'grievance', 'COVID prevention', 'assessment', 'tutorial', 'how to', 'demo', 'development', 'personal growth',
  'skills', 'regulations', 'communication'];